"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tx = void 0;
// used for typing translation keys where they need to be passed to a string
const tx = (key) => key;
exports.tx = tx;
